"use client";

import { c as _c } from "react/compiler-runtime";
import { Grid } from "@opensea/ui-kit";
import { range } from "es-toolkit";
import { GridItemSkeleton } from "../../GridItemSkeleton";
import { useItemView } from "../../ItemViewProvider";
const ITEMS = range(50).map(() => undefined);
export function ProfileItemsGridSkeleton(t0) {
  const $ = _c(5);
  const {
    overrides
  } = t0;
  const {
    size
  } = useItemView();
  let t1;
  if ($[0] !== overrides) {
    t1 = t2 => {
      const {
        index: index_0
      } = t2;
      return <GridItemSkeleton key={index_0} overrides={overrides} />;
    };
    $[0] = overrides;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== size || $[3] !== t1) {
    t2 = <Grid className="pb-4" itemKey={_temp} items={ITEMS} renderItem={t1} size={size} />;
    $[2] = size;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(_, index) {
  return String(index);
}